export default __webpack_public_path__ + "static/media/day_filled.b42004e0.svg";